import styled from 'styled-components';

import DataError from './DataError';

export const SmallDataError = styled(DataError)`
  h1 {
    font-size: 2.4rem;
    line-height: 3.6rem;
    margin: 1.7rem 0;
  }

  img {
    width: 48px;
  }

  a {
    font-size: 1.7rem;
  }
`;
